import { render, staticRenderFns } from "./customSaleNew.vue?vue&type=template&id=f56048ea"
import script from "./customSaleNew.vue?vue&type=script&lang=js"
export * from "./customSaleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports